module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=TC - Turks and Caicos Islands.bddd36c6.svg";